import { InstallmentStateEnum } from './Loan';
import { PaymentPlanData } from './PaymentPlan';

export enum StandardPaymentType {
  PayOffDebt = 'PAY_OFF_DEBT',
  PayFee = 'PAY_1_FEE',
}

export enum TransactionReasonTexts {
  POP = 'Cancelación de préstamo', // Amortización total
  DE1 = 'Deuda 1 cuota',
  DEC = 'Reduce tu deuda',// Deuda CO (no total)
  DEM = 'Deuda manual',
  DET = 'Deuda total',
  DEP = 'Deuda pendiente + próxima cuota', // Deuda + pago adelantado
  DEU = 'Deuda unica',
  PAN = 'Adelantar una cuota',
  PPC = 'Amortización parcial cuota',
  PPO = 'Amortización parcial plazo',
  RCA = 'Recobro automatico',
  RCO = 'Recobro automático en Charge Off',
  REM = 'Remesa',
  REV = 'Devolución importe el cliente',
  ALT = 'Alta de tarjeta',
  RTF = 'Recobro telefónico',
  PPG = 'Pagar todo', // Pago deuda total CO con plan de pagos
  PCO = 'Pagar todo', // Pago deuda total CO sin plan de pagos
  CPP = 'Crea tu plan de pagos'
}
export enum TransactionReasonEnum {
  POP = 'POP',
  DE1 = 'DE1',
  DEC = 'DEC',
  DEM = 'DEM',
  DET = 'DET',
  DEP = 'DEP',
  DEU = 'DEU',
  PAN = 'PAN',
  PPC = 'PPC',
  PPO = 'PPO',
  RCA = 'RCA',
  RCO = 'RCO',
  REM = 'REM',
  REV = 'REV',
  ALT = 'ALT',
  RTF = 'RTF',
  PPG = 'PPG',
  PCO = 'PCO',
  CPP = 'CPP',
}

export enum PromotionTypeTexts {
  H24 = '24 horas',
  DIRECT_DEBIT_ERROR = 'Error de domiciliación',
  PAY_TWO_FEES = 'Paga dos cuotas',
  SPECIAL = 'Especial',
  IN_ADVANCE = 'Pago anticipado',
  DEBT_PLUS_IN_ADVANCE = 'Deuda actual + Adelanta cuota',
  SETTLE = 'Cancelar la deuda',
  AGED_TOTAL_DEBT_CHARGE_OFF = 'Cancelar deuda total CO antigua',
  TOTAL_DEBT_PAYMENT_PLAN = 'Cancelar deuda total con plan de pagos',
  RECENT_TOTAL_DEBT_CHARGE_OFF = 'Cancelar deuda total CO reciente',
  DEBT_AMORTIZATION = 'Amortización de deuda por parte del cliente',
  PAYMENT_PLAN = 'Creación del plan de pagos',
}

export enum PromotionTypeEnum {
  H24 = '24H',
  DIRECT_DEBIT_ERROR = 'DIRECT_DEBIT_ERROR',
  PAY_TWO_FEES = 'PAY_TWO_FEES',
  SPECIAL = 'SPECIAL',
  IN_ADVANCE = 'IN_ADVANCE',
  DEBT_PLUS_IN_ADVANCE = 'DEBT_PLUS_IN_ADVANCE',
  SETTLE = 'SETTLE',
  AGED_TOTAL_DEBT_CHARGE_OFF = 'AGED_TOTAL_DEBT_CHARGE_OFF',
  TOTAL_DEBT_PAYMENT_PLAN = 'TOTAL_DEBT_PAYMENT_PLAN',
  RECENT_TOTAL_DEBT_CHARGE_OFF = 'RECENT_TOTAL_DEBT_CHARGE_OFF',
  DEBT_AMORTIZATION = 'DEBT_AMORTIZATION',
  PAYMENT_PLAN = 'PAYMENT_PLAN',
}

export enum ProducType {
  PersonalLoan = 'PERSONAL_LOAN',
  CustomerLoan = 'CONSUMER_LOAN',
}
export interface LoanInstallments {
  order: 1;
  due_date: string;
  fee: 200.75;
  opening_fee: 10.75;
  interest_fee: 30.25;
  principal_fee: 159.75;
  insurance_fee: 0;
  state: InstallmentStateEnum;
  arrears: 0;
  return_expenses: 0;
  days_past_due: 10;
  unpaid_opening_fee: 10.75;
  unpaid_interest_fee: 30.25;
  unpaid_principal_fee: 159.75;
  unpaid_insurance_fee: 0;
}

export interface LoanData {
  loan_id: string;
  ag_code: string;
  loan_reference: number;
  collecting_account: string;
  next_due_fee: number;
  product_type: ProducType;
  installments: LoanInstallments[];
  certified_debt?: number;
  payment_plan?: PaymentPlanData[];
  transaction_reason?: TransactionReasonEnum;
  allow_creation_payment_plan?: boolean;
  type?: StandardPaymentType | PromotionTypeEnum;
}

export interface CoLoanData {
  loan_id: string;
  ag_code: string;
  loan_reference: number;
  collecting_account: string;
  next_due_fee: number;
  product_type: ProducType;
  installments: LoanInstallments[];
  certified_debt?: number;
  payment_plan?: PaymentPlanData[];
  transaction_reason?: TransactionReasonEnum;
  allow_creation_payment_plan?: boolean;
  type?: StandardPaymentType | PromotionTypeEnum;
}
export interface PromotionsData {
  loan_id: string;
  type: StandardPaymentType | PromotionTypeEnum;
  amount: number;
  amount_excused: number; // Importe a condonar
  expiration_date?: string;
  transaction_reason: TransactionReasonEnum;
  category: string;
}

export interface StandardPaymentsData {
  loan_id: string;
  type: StandardPaymentType | PromotionTypeEnum;
  amount: number;
  amount_excused: number;
  transaction_reason: TransactionReasonEnum;
  category?: string;
}

export interface DebtResponse {
  amount: number;
  min_payment_amount: number;
  loans: LoanData[];
  promotions: PromotionsData[];
  standard_payments: StandardPaymentsData[];
}

export enum amountType {
  PRO = 'PRO',
  STD = 'STD',
}
export interface AmountSelectedType {
  index: number;
  type: amountType;
}

